package music.jammers.client.shared.admin.presentation.model

import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource

data class SettingItem(
    val title: StringResource,
    val icon: DrawableResource
)